import { ShopProduct } from '@repo/shop/types'
import { FunctionComponent } from 'react'
import { PageDto } from '../../types/page.types'
import CartProduct from './CartProduct'

interface Props {
  pageDto: PageDto
  products: ShopProduct[]
  onClick?: () => void
  onRemove?: (urlSlug: string) => void
}

const CartProducts: FunctionComponent<Props> = ({ pageDto, products, onClick, onRemove }) => {
  if ((products || []).length === 0) {
    return null
  }

  const baseProps = {
    pageDto,
    onClick,
    onRemove,
    className: 'ml-3 w-40 snap-start last:mr-3',
  }

  return (
    <ul className='flex shrink-0 snap-x snap-mandatory scroll-pl-3 items-stretch overflow-auto pb-5 pt-2'>
      {products?.map((product, i) => <CartProduct {...baseProps} key={i} product={product} />)}
    </ul>
  )
}

export default CartProducts
